export default {
    title: 'Ludzie',
    subtitle: '{n} osoba | {n} osoby | {n} osób',
    newPerson: 'Nowa osoba',
    search: 'Szukaj osoby',
    add: {
        placeholder: 'Dodaj osobę…',
        save: 'Dodaj',
        hint: 'Enter dodaje — imię, resztę uzupełnisz po prawej',
    },
    kinds: {
        birthday: 'Urodziny',
        nameday: 'Imieniny',
        anniversary: 'Rocznica',
        custom: 'Własna',
    },
    kindsShort: {
        birthday: 'urodziny',
        nameday: 'imieniny',
        anniversary: 'rocznica',
    },
    contactKinds: {
        call: 'Rozmowa',
        meeting: 'Spotkanie',
        message: 'Wiadomości',
        other: 'Inny',
    },
    every: {
        none: 'Brak',
        week: 'Co tydzień',
        twoWeeks: 'Co 2 tyg.',
        month: 'Co miesiąc',
        threeMonths: 'Co 3 mies.',
        days: 'Co {n} dni',
    },
    when: {
        today: 'dziś',
        tomorrow: 'jutro',
        inDays: 'za {n} dzień | za {n} dni | za {n} dni',
    },
    ago: {
        today: 'dziś',
        yesterday: 'wczoraj',
        days: '{n} dzień temu | {n} dni temu | {n} dni temu',
        weeks: '{n} tydz. temu',
        months: '{n} mies. temu',
        years: '{n} rok temu | {n} lata temu | {n} lat temu',
    },
    age: {
        birthday: 'skończy {n}',
        birthdayToday: 'kończy {n}',
        years: '{n}. rocznica',
    },
    badge: '{when} · {what}',
    due: 'dawno',
    dueTitle: 'Dawno bez kontaktu',
    list: {
        noDate: 'Bez dat',
    },
    groups: {
        title: 'Grupy',
        all: 'Wszyscy',
        none: 'Bez grupy',
        add: 'Nowa grupa',
        pick: 'Grupa',
        edit: 'Zmień grupę „{name}"',
        name: 'Nazwa grupy',
        namePlaceholder: 'np. Rodzina, Praca, Przyjaciele',
        color: 'Kolor',
        save: 'Zapisz',
        cancel: 'Anuluj',
        remove: 'Usuń',
        removed: 'Usunięto grupę „{name}" — osoby zostały',
    },
    empty: {
        title: 'Nikogo tu jeszcze nie ma',
        text: 'Dodaj osobę, o której chcesz pamiętać — z urodzinami, pomysłami na prezent i tym, kiedy ostatnio rozmawialiście.',
        noMatchTitle: 'Nikt nie pasuje',
        noMatchText: 'Zmień frazę albo wyczyść pole szukania.',
    },
    googleBirthdays: {
        open: 'Importuj urodziny z Google',
        title: 'Urodziny z Google',
        intro: 'Urodziny Twoich kontaktów z Kalendarza Google. Zaznaczone dopiszemy do osób, a brakujące osoby dodamy.',
        loading: 'Wczytuję urodziny z Google…',
        notConnected: 'Połącz Kalendarz Google, żeby zaimportować urodziny kontaktów.',
        connect: 'Połącz Kalendarz Google',
        loadFailed: 'Nie udało się wczytać urodzin z Google.',
        retry: 'Spróbuj ponownie',
        none: 'Google nie ma urodzin Twoich kontaktów.',
        checkAll: 'Zaznacz wszystkie',
        uncheckAll: 'Odznacz wszystkie',
        already: 'już jest',
        toPerson: 'dopiszemy do osoby',
        newPerson: 'nowa osoba',
        add: 'Dodaj {n} | Dodaj {n} | Dodaj {n}',
        saveFailed: 'Nie udało się zapisać urodzin.',
        added: 'Dodano urodziny: {n}',
        nothingAdded: 'Wszystkie te urodziny już były',
    },
    pick: {
        title: 'Wybierz osobę',
        text: 'Albo dodaj nową w polu nad listą.',
    },
    person: {
        name: 'Imię',
        namePlaceholder: 'Imię',
        nickname: 'Określenie',
        nicknamePlaceholder: 'jak ją nazywasz, np. mama, szef',
    },
    dates: {
        title: 'Ważne daty',
        add: 'Dodaj datę',
        kind: 'Rodzaj',
        day: 'Dzień',
        month: 'Miesiąc',
        year: 'Rok',
        yearPlaceholder: 'rok',
        label: 'Nazwa',
        labelPlaceholder: 'np. Ślub, Rocznica poznania',
        save: 'Dodaj',
        cancel: 'Anuluj',
        remove: 'Usuń datę',
        empty: 'Urodziny, imieniny, rocznica — wrócą co roku w Planerze i w „Teraz".',
        leap: '29 lutego — w latach bez niego 28 lutego',
    },
    gifts: {
        title: 'Pomysły na prezent',
        placeholder: 'Dopisz pomysł i naciśnij Enter',
        given: 'Dane ({n})',
        givenOn: 'dany {date}',
        markGiven: 'Oznacz jako dany',
        unmark: 'Jeszcze nie dany',
        remove: 'Usuń pomysł',
        empty: 'Gdy coś wpadnie Ci w oko albo usłyszysz „przydałby mi się…", zapisz to tutaj.',
    },
    contacts: {
        title: 'Kontakty',
        talkedToday: 'Dziś rozmawialiśmy',
        kind: 'Rodzaj',
        date: 'Dzień',
        notePlaceholder: 'O czym? (opcjonalnie)',
        save: 'Zapisz',
        cancel: 'Anuluj',
        remove: 'Usuń kontakt',
        empty: 'Jeszcze bez kontaktu.',
        last: 'Ostatnio: {when}',
    },
    often: {
        title: 'Jak często',
        hint: 'Gdy minie tyle czasu od ostatniego kontaktu, osoba pojawi się w „Teraz".',
        due: 'Dawno bez kontaktu — może czas się odezwać?',
    },
    notes: {
        title: 'Notatka',
        placeholder: 'Co lubi, o czym ostatnio mówiła, rozmiar butów…',
    },
    toolbar: {
        back: 'Wróć do listy',
        remove: 'Usuń osobę',
        saving: 'Zapisywanie…',
        saved: 'Zapisano',
        saveError: 'Nie udało się zapisać — spróbujemy przy następnej zmianie',
    },
    toast: {
        removed: 'Usunięto osobę',
        undo: 'Cofnij',
    },
    planner: {
        birthday: '🎂 Urodziny: {name}',
        nameday: '🌷 Imieniny: {name}',
        anniversary: '💍 Rocznica: {name}',
        custom: '📅 {label}: {name}',
        withAge: '{title} ({n})',
    },
    help: {
        add: {
            title: 'Dodaj osobę',
            text: 'Wpisz imię i naciśnij Enter. Resztę — daty, pomysły, kontakty — uzupełnisz po prawej.',
            more: 'Osoba trafia do grupy, którą akurat oglądasz. Asystent też dopisze osobę, gdy powiesz np. „Kasia ma urodziny 14 marca".',
        },
        groups: {
            title: 'Grupy',
            text: 'Rodzina, Praca, Przyjaciele… Wybierz grupę, żeby zobaczyć tylko jej osoby.',
            more: 'Osoba jest w najwyżej jednej grupie — ustawiasz ją przy osobie. Nazwę, kolor i usunięcie znajdziesz pod „…" przy grupie (na telefonie: tapnij wybraną pigułkę jeszcze raz). Usunięcie grupy zostawia osoby.',
        },
        list: {
            title: 'Twoi ludzie',
            text: 'Na górze ci, których ważna data jest najbliżej, dalej alfabetycznie. Plakietka mówi, co i kiedy — „za 3 dni · urodziny".',
            more: 'Pomarańczowa kropka „dawno" znaczy, że minęło więcej czasu od kontaktu, niż ustawiłeś w „Jak często".',
        },
        dates: {
            title: 'Ważne daty',
            text: 'Urodziny, imieniny, rocznica albo własna data z nazwą. Wracają co roku: widać je w Planerze, a tydzień wcześniej w „Teraz".',
            more: 'Rok jest opcjonalny — gdy go podasz, zobaczysz wiek albo którą rocznicę. Imieniny pojawią się w „Teraz" tylko w sam dzień.',
        },
        gifts: {
            title: 'Pomysły na prezent',
            text: 'Zapisuj, co komuś mogłoby się spodobać. Gdy wręczysz, zaznacz — pomysł zostaje w historii pod „Dane".',
            more: 'Przy zbliżających się urodzinach „Teraz" przypomni, ile pomysłów czeka.',
        },
        contacts: {
            title: 'Kontakty',
            text: '„Dziś rozmawialiśmy" zapisuje rozmowę, spotkanie albo wiadomości, z krótką notatką. Najnowszy to ostatni kontakt.',
            more: 'Asystentowi wystarczy powiedzieć „rozmawiałem z mamą o wakacjach".',
        },
        often: {
            title: 'Jak często',
            text: 'Ustaw, jak często chcesz się odzywać. Gdy minie ten czas od ostatniego kontaktu, osoba pojawi się w „Teraz".',
            more: 'Bez ustawienia nic się nie przypomina.',
        },
    },
    tour: {
        welcome: {
            title: 'Witaj w Ludziach',
            description: 'Miejsce na osoby, o których chcesz pamiętać: kiedy mają urodziny, co im podarować i kiedy ostatnio rozmawialiście. To nie książka adresowa — bez telefonów i adresów.',
        },
        person: {
            title: 'Osoba',
            description: 'Po prawej: imię i określenie („mama", „szef"), grupa, ważne daty, pomysły na prezent, kontakty, jak często i notatka. Wszystko zapisuje się samo.',
        },
        end: {
            title: 'To wszystko',
            description: 'Przewodnik wróci zawsze pod przyciskiem „Pomoc" — tam są też Pierwsze kroki. A „Co to?" przy sekcji wyjaśnia ją bez przewodnika.',
        },
    },
    firstSteps: {
        person: {
            title: 'Pierwsza osoba',
            action: 'Dodaj osobę',
            what: 'Wpisz imię w pole „Dodaj osobę…" i naciśnij Enter.',
            why: 'Od tego zaczyna się wszystko: daty, prezenty i kontakty są przy osobie.',
        },
        date: {
            title: 'Ważna data',
            action: 'Dodaj datę',
            what: 'Otwórz osobę i dodaj jej urodziny, imieniny albo rocznicę.',
            why: 'Data wróci co roku w Planerze, a tydzień wcześniej w „Teraz" — zdążysz z prezentem.',
        },
        gift: {
            title: 'Pomysł na prezent',
            action: 'Zapisz pomysł',
            what: 'Dopisz przy osobie pomysł na prezent — coś, o czym wspomniała.',
            why: 'Gdy przyjdą urodziny, nie zaczynasz od zera.',
        },
        contact: {
            title: 'Kontakt',
            action: 'Zapisz rozmowę',
            what: 'Kliknij „Dziś rozmawialiśmy" przy osobie i dopisz, o czym.',
            why: 'Widzisz, kiedy ostatnio byliście w kontakcie — a z „Jak często" asystent przypomni, gdy minie za dużo czasu.',
        },
    },
};
